(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name autoRosterSchedule.service:autoRosterScheduleService
     *
     * @description
     *
     */
    angular
        .module('autoRosterSchedule')
        .service('AutoRosterScheduleService', AutoRosterScheduleService);

    function AutoRosterScheduleService(RemoteService, AutoRosterScheduleRequestFactory, $sce) {
        var self = this,searchCriteria,saveReq, changeStatusReq;
        self.schedule_blocks = {
            DISTRIBUTE: "Distribute Pairings",
            DELETED: "Delete Pairings",
            DISTRIBUTE_STANDBY: "Distribute Standby",
            DISTRIBUTE_DEADHEAD:"Distribute Dead Head pairings",
            DISTRIBUTE_CONTRACT_OFF:"Distribute Contract Off",
            DELETE_CONTRACT_OFF:"Delete Contract Off",
            DISTRIBUTE_CAL_CONTRACT_OFF:"Distribute Calendar Contract Off",
            DISTRIBUTE_STANDBY_CONSIDERING_FLIGHTS: "Distribute Standby Considering flights"
        };
        self.schedule_status = {
            CANCELLED:"Cancelled",
            REQUESTED: "Requested",
            ERROR: "error",
            COMPLETED: "completed",
            PROCESSING: "processing",
            STOPPED: "Stopped"
        };
        self.model = {
            rosterCycles:null,
            autoScheduleSearchCriteria: AutoRosterScheduleRequestFactory.getAutoRosterScheduleSearchRequest(),
            autoScheduleSaveReq: AutoRosterScheduleRequestFactory.getSaveAutoRosterScheduleRequest(),
            autoScheduleChangeStatusReq: AutoRosterScheduleRequestFactory.getAutoRosterScheduleStatusChangeReq()
        };

        self.getRosterAutoScheduleSearchCriteria = function () {
            return self.model.autoScheduleSearchCriteria;
        };

        self.getRosterAutoScheduleSaveReq = function () {
            self.model.autoScheduleSaveReq = AutoRosterScheduleRequestFactory.getSaveAutoRosterScheduleRequest();
            return self.model.autoScheduleSaveReq;
        };

        self.getAutoRosterChangeStatusReq = function () {
            return self.model.autoScheduleChangeStatusReq;
        };

        self.setUseIgnoreOverlap = function () {
            saveReq.ignoreOverlap = true;
        };

        self.setUseIgnorePeriodValid = function () {
            saveReq.ignorePeriodValid = true;
        };

        self.setRosterAutoScheduleChangeStatusReq = function (req) {
            changeStatusReq = AutoRosterScheduleRequestFactory.getAutoRosterScheduleStatusChangeReq();
            changeStatusReq.autoScheduleSetupId = req.autoScheduleSetupId;
            changeStatusReq.version = req.version;
            changeStatusReq.status = req.status;
            changeStatusReq.changeStatusTo = req.newStatus;
        };

        self.setRosterAutoScheduleSaveReq = function (req) {
            saveReq = AutoRosterScheduleRequestFactory.getSaveAutoRosterScheduleRequest();
            saveReq.fromDate = req.fromDate;
            saveReq.toDate = req.toDate;
            saveReq.scheduleDate = req.scheduleDate;
            saveReq.status = req.status;
            saveReq.scheduleTime = req.scheduleTime;
            saveReq.ignoreOverlap = req.ignoreOverlap;
            saveReq.ignorePeriodValid = req.ignorePeriodValid;
            saveReq.changeStatusTo = req.changeStatusTo;
            saveReq.version = req.version;
            if(req.cycle!==null){
                saveReq.cycleId = req.cycle && req.cycle.cycleId;
            }


            if(req.isSelectCrews!==null && req.isSelectCrews){

              saveReq.crewProfileIdList = [];
              angular.forEach(req.crewIDsList, function (item) {
                saveReq.crewProfileIdList.push(item.crewProfileId);
              });

              saveReq.patternNameList = [];
              angular.forEach(req.patternNames, function (item) {
                saveReq.patternNameList.push(item.patternName);
              });

              saveReq.isSelectCrews = true;

              if(req.crewTypeCodesList!==null){
                saveReq.crewTypeCodesList = [];
                saveReq.crewTypeCodesList.push(req.crewTypeCodesList.crewTypeCode);
              }

            } else {

              saveReq.isSelectCrews = false;

              if(req.crewTypeCodesList!==null){
                saveReq.crewTypeCodesList = [];
                angular.forEach(req.crewTypeCodesList, function (item) {
                  saveReq.crewTypeCodesList.push(item.crewTypeCode);
                });
              }
            }


           if(!!req.airCraftTypesList){
                saveReq.airCraftTypes = [];
                //saveReq.airCraftType = req.airCraftTypesList[0].modelNumber;
                angular.forEach(req.airCraftTypesList, function (item) {
                    if(!!item.airCraftType){
                    	saveReq.airCraftTypes.push(item.airCraftType);
                    }
                });
            }

          if(req.distributionGroupsList!==null){
                        console.log(req.distributionGroupsList);
                        saveReq.distributionGroups = [];
                        angular.forEach(req.distributionGroupsList, function (item) {
                            console.log(item.labelFieldName);
                            saveReq.distributionGroups.push(item.labelFieldName);
                          });
                      }

            if(req.crewBase!==null && !angular.isUndefined(req.crewBase )){
                saveReq.crewBase = req.crewBase.airPortCode;
            }
            if(req.isDeleteBlock!==null && req.isDeleteBlock){
                saveReq.isDeleteBlock = "Y";
            }else{
                saveReq.isDeleteBlock = "N";
            }
            if(req.isDistBlock!==null && req.isDistBlock){
                saveReq.isDistBlock = "Y";
            }else{
                saveReq.isDistBlock = "N";
            }
          if(req.isDistStandby!==null && req.isDistStandby){
            saveReq.isDistStandby = "Y";
            if(req.selectedStandbyStrategy!==null && !angular.isUndefined(req.selectedStandbyStrategy)){
              saveReq.standbyStrategyId = req.selectedStandbyStrategy.standbyStrategyId;
            }
          }else{
            saveReq.isDistStandby = "N";
          }

          if(req.isDistDHD!==null && req.isDistDHD){
            saveReq.isDistDHD = "Y";
          }else{
            saveReq.isDistDHD = "N";
          }

          if(req.isDistContractOff!==null && req.isDistContractOff){
            saveReq.isDistContractOff = "Y";
          } else{
            saveReq.isDistContractOff = "N";
          }

          if(req.isDelContractOff!==null && req.isDelContractOff){
            saveReq.isDelContractOff = "Y";
          } else{
            saveReq.isDelContractOff = "N";
          }

          if(req.isDistCalContractOff!==null && req.isDistCalContractOff){
            saveReq.isDistCalContractOff = "Y";
          } else {
            saveReq.isDistCalContractOff = "N";
          }

          if(req.isDistributeStandbyConsideringFlights!==null && req.isDistributeStandbyConsideringFlights){
            saveReq.isDistributeStandbyConsideringFlights = "Y";
            if(req.selectedStandbyStrategy!==null && !angular.isUndefined(req.selectedStandbyStrategy)){
              saveReq.standbyStrategyId = req.selectedStandbyStrategy.standbyStrategyId;
            }
          } else {
            saveReq.isDistributeStandbyConsideringFlights = "N";
          }

        };

        self.setDefaultCrewBase = function (crewBaseList, crewBase) {
            self.model.autoScheduleSearchCriteria.crewBase = _.find(crewBaseList, {"airPortCode": crewBase});
        };

        self.setRosterSearchCriteria = function (passCriteria) {
            searchCriteria = AutoRosterScheduleRequestFactory.getAutoRosterScheduleSearchRequest();
            searchCriteria.fromDate = passCriteria.fromDate;
            searchCriteria.toDate = passCriteria.toDate;
            searchCriteria.pageSize = passCriteria.pageSize;
            searchCriteria.startPosition = passCriteria.startPosition;
            if(!!passCriteria.crewBase){
                searchCriteria.crewBase = passCriteria.crewBase.airPortCode;
            }
            if(!!passCriteria.crewTypeCodesList && passCriteria.crewTypeCodesList.length>0){
                searchCriteria.crewTypeCodesList = [];
                angular.forEach(passCriteria.crewTypeCodesList, function (crewType) {
                    searchCriteria.crewTypeCodesList.push(crewType.crewTypeCode);
                });
            }
            if(!!passCriteria.airCraftTypes){
            	searchCriteria.airCraftTypes = [];
                searchCriteria.airCraftTypes.push(passCriteria.airCraftTypes.airCraftType);
            }
            if(!!passCriteria.cycle){
                searchCriteria.cycleId = passCriteria.cycle.cycleId;
            }
        };

        self.setCheckCsbSearchCriteria = function (passCriteria) {
            searchCriteria = AutoRosterScheduleRequestFactory.getAutoRosterScheduleCheckCSBReq();
            if(!!passCriteria && passCriteria.length>0){
                searchCriteria.autoScheduleSetupIdList = [];
                angular.forEach(passCriteria, function (autoSchedule) {
                    searchCriteria.autoScheduleSetupIdList.push(autoSchedule.autoScheduleSetupId);
                });
            }
        };

        self.saveAutoRosterSchedule = function (successFn, errorFn) {
            RemoteService.saveAutoRosterSchedule(saveReq).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        self.changeStatusRosterSchedule = function (successFn, errorFn) {
            RemoteService.changeStatusAutoRosterSchedule(changeStatusReq).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error);
                }
            );
        };
        self.deleteAutoRosterDistribution = function (autoScheduleSetupId, successFn, errorFn) {
            RemoteService.deleteAutoRosterDistribution(autoScheduleSetupId).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        self.searchAutoRosterSchedule = function (successFn, errorFn) {
            RemoteService.loadRosterSchedules(searchCriteria).then(
                function (response) {
                    if (response.success){
                        successFn(adapetResponse(response));
                    }
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        self.searchAutoRosterScheduleCheckCSB = function (successFn, errorFn) {
            RemoteService.loadRosterSchedulesCheckCSB(searchCriteria).then(
                function (response) {
                    if (response.success){
                        successFn(response);
                    }
                },
                function (error) {
                    errorFn(error);
                }
            );
        };


        self.getRosterCycles = function (successFn, errorFn) {
            if (self.model.rosterCycles === null) {
                RemoteService.getRosterCycles(true).then(
                    function (response) {
                        if (response.success){
                            self.model.rosterCycles = response.cycleList;
                            successFn(self.model.rosterCycles);
                        }
                    },
                    function (error) {
                        errorFn(error);
                    }
                );
            } else {
                successFn(self.model.rosterCycles);
            }
        };

        self.getTrainerTraineeList = function (crewType, successFn, errorFn) {
            RemoteService.loadTrainerTraineeList(crewType).then(
                function (response) {
                    if (response.success){
                        successFn(response);
                    }
                },
                function (error) {
                    errorFn(error);
                }
            );
        }

      self.getStrategies = function (successFn, errorFn) {
        RemoteService.loadStrategies().then(
          function (response) {
            if (response.success) {
              successFn(response.standByStrategiesList);
            }
          },
          function (error) {
            errorFn(error);
          }
        );
      };

        self.getScheduleStatusMap = function () {
            return self.schedule_status;
        };

        function adapetResponse(response){
            if (response.autoScheduleResponse.length>0){
                response.autoScheduleResponse = _.each(response.autoScheduleResponse, function (obj) {
                    var description = "";
                    if(obj.isDistBlock==='Y'){
                        description += self.schedule_blocks.DISTRIBUTE;
                    }
                    if(obj.isDeleteBlock==='Y'){
                        description += ", " + self.schedule_blocks.DELETED;
                    }
                    if(obj.isDistStandby==='Y'){
                      description += ", " + self.schedule_blocks.DISTRIBUTE_STANDBY;
                    }

                    if(obj.isDistDHD==='Y'){
                      description += ", " + self.schedule_blocks.DISTRIBUTE_DEADHEAD;
                    }

                    if(obj.isDistContractOff==='Y'){
                      description += ", " + self.schedule_blocks.DISTRIBUTE_CONTRACT_OFF;
                    }

                    if(obj.isDelContractOff==='Y'){
                      description += ", " + self.schedule_blocks.DELETE_CONTRACT_OFF;
                    }

                    if(obj.isDistCalContractOff==='Y'){
                      description += ", " + self.schedule_blocks.DISTRIBUTE_CAL_CONTRACT_OFF;
                    }

                    if(obj.isDistributeStandbyConsideringFlights==='Y'){
                      description += ", " + self.schedule_blocks.DISTRIBUTE_STANDBY_CONSIDERING_FLIGHTS;
                    }

                    if(obj.airCraftTypes!==null && !angular.isUndefined(obj.airCraftTypes)){
                        description += "</br> " + obj.airCraftTypes;
                    }
                      if(obj.crewBase!==null && !angular.isUndefined(obj.crewBase)){
                          description += "</br> " + obj.crewBase ;
                    }
                    if(description.charAt(0)===","){
                        description = description.substr(1);
                    }
                    obj.description = $sce.trustAsHtml(description);
                });
            }
            return response;
        }
    }
})();
